import React from "react";

const CookiesPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-center">Cookies Policy</h1>
      <p className="mb-4 text-center text-gray-600">Effective Date: Launch Date</p>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
        <p>
          This Cookies Policy explains how <strong>Bliss Distro</strong> uses cookies and similar technologies to enhance user experience, analyze site traffic, and personalize content. By using our website, you agree to our use of cookies as described in this policy.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">2. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a website. They help websites remember your preferences, login information, and browsing behavior.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">3. Types of Cookies We Use</h2>
        <ul className="list-disc ml-6">
          <li><strong>Essential Cookies:</strong> Necessary for core website functionality such as authentication and security.</li>
          <li><strong>Performance Cookies:</strong> Help us analyze how visitors use our website to improve user experience.</li>
          <li><strong>Functional Cookies:</strong> Remember user preferences and settings.</li>
          <li><strong>Targeting/Advertising Cookies:</strong> Used to deliver relevant ads and measure their effectiveness.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">4. Managing Cookies</h2>
        <p>
          You can control and delete cookies through your browser settings. Disabling certain cookies may affect website functionality.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">5. Third-Party Cookies</h2>
        <p>
          We may allow third-party services, such as analytics providers and advertisers, to set cookies on our website. These third parties have their own privacy policies regarding the use of cookies.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">6. Updates to This Policy</h2>
        <p>
          We may update this Cookies Policy periodically. Any changes will be posted on this page, and we encourage you to review it regularly.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">7. Contact Us</h2>
        <p>
          If you have any questions about our use of cookies, please contact us at:
        </p>
        <p className="font-medium">
          Email: <a href="mailto:support@blissdistro.com" className="text-blue-600 hover:underline">support@blissdistro.com</a>
        </p>
      </section>
    </div>
  );
};

export default CookiesPolicy;